export default "__VITE_ASSET__BchqTu0X__"